<app-list-table-filters-wrapper
  [title]="'My Support Tickets' | translate"
  [parentRoute]="'/user-support'"
  [subtitle]="'View and manage your support tickets' | translate"
  [columns]="tableColumns"
  [service]="service"
  [getAllMethod]="getAllMethod"
  [getTotalMethod]="getTotalMethod"
  [(filterModel)]="filterModel"
  [filtersForms]="filtersForms"
  (applyFilters)="applyFilters()"
  (clearFilters)="clearFilters()"
  [isLoading]="loading"
  [storageKey]="storageKey"
  [toggleFilter]="toggleFilter"
  [defaultParams]="defaultParams"
  (onRowClick)="goToChat($event)"
  [filtersParams]="filtersParams">

  <ng-template #createAt let-row>
    {{ row.createAt | dateFormatLang:tr.currentLang:true }}
  </ng-template>
  
  <ng-template #moduleNameTemplate let-row>
    {{ getLocalizedModuleNameByName(row.moduleName) }}
  </ng-template>
  
  <ng-template #statusTemplate let-row>
    <p-tag 
      [value]="getStatusLabel(row.ticketStatus)"
      [severity]="getStatusSeverity(row.ticketStatus)">
    </p-tag>
  </ng-template>
  
  <ng-template #actionsTemplate let-row>
    <button
      pButton
      type="button"
      icon="pi pi-comments"
      class="p-button-text p-button-sm"
      (click)="goToChat(row)"
      [title]="'View Chat' | translate">
    </button>
  </ng-template>

  <div controller>
    <p-button 
      [label]="'Create Ticket' | translate" 
      icon="pi pi-plus" 
      (onClick)="openCreateTicketModal()"
      styleClass="p-button-primary">
    </p-button>
  </div>

</app-list-table-filters-wrapper>

<!-- Create Ticket Modal -->
<p-dialog [resizable]="false" [draggable]="false" 
  [header]="'Create New Ticket' | translate" 
  [(visible)]="showCreateTicketModal" 
  [modal]="true" 
  [style]="{width: '50vw'}"
  [closable]="true"
  (onHide)="closeCreateTicketModal()">
  
  <div class="flex flex-column gap-3">
    <div class="field">
      <label for="moduleName">{{ 'Module Name' | translate }} *</label>
      <app-dropdown 
        id="moduleName"
        [(ngModel)]="newTicket.moduleName"
        [options]="moduleOptions"
        [placeholder]="'Select module' | translate"
        [optionLabel]="'label'"
        [optionValue]="'value'"
        styleClass="w-full">
      </app-dropdown>
    </div>

    <div class="field">
      <label for="exceptionJson">{{ 'Error Details' | translate }}</label>
      <textarea 
        id="exceptionJson"
        class="w-full"
        [(ngModel)]="newTicket.exceptionJson"
        [placeholder]="'Enter error details' | translate"
        rows="4"
        style="width: 100%; padding: 0.5rem; border: 1px solid #ccc; border-radius: 4px;">
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button 
        [label]="'Cancel' | translate" 
        icon="pi pi-times" 
        (onClick)="closeCreateTicketModal()"
        styleClass="p-button-text">
      </p-button>
      <p-button 
        [label]="'Create Ticket' | translate" 
        icon="pi pi-check" 
        (onClick)="createTicket()"
        [disabled]="!newTicket.moduleName || loading"
        [loading]="loading"
        styleClass="p-button-primary">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
